<div style="position: relative;">
  <div id="activity" class="cursor-pointer activity-dropdown btn-header" (click)="onToggle()" [class.active]="active"
    title="{{'header_icon_notification' | i18n}}">
    <span>
      <a><i class="fa fa-bell-o"></i></a>
    </span>
    <b class="badge bg-color-red" *ngIf="count!=0">{{count}}</b>
  </div>

  <div class="ajax-dropdown header-notification-align" #dropdown>
    <div class="notification-header-bar d-flex flex-row">
      <div class="notification-header-left">
        <span class="noti-header-title">
          {{'header_icon_notification' | i18n}}
        </span>
      </div>
      <div class="notification-header-right">
        <label class="notification-switch-label" for="notificationUnreadToggle">
          <span class="notification-switch-text primary-font">{{'header_notification_only_unread' | i18n}}</span>
          <input type="checkbox" id="notificationUnreadToggle" class="notification-switch" role="switch"
            [checked]="onlyUnread" (change)="onToggleUnread($any($event.target).checked)">
        </label>
        <button *ngIf="count > 0" type="button" class="notification-mark-all theme-color-text" (click)="markAllAsRead()"
          [disabled]="isMarkingAllRead" title="{{'header_notification_mark_all_read' | i18n}}"
          aria-label="{{'header_notification_mark_all_read' | i18n}}">
          <i class="fa fa-envelope-open theme-color-text" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <ng-container *ngIf="notifyLength!=0">
      <!-- notification content -->
      <div class="ajax-notifications custom-scroll bg3-color" id="notificationPanel">
        <ul class="notification-body" id="notifyId" *ngIf="currentActivity">
          <ng-template ngFor let-item [ngForOf]="currentActivity.data">
            <li [id]="item.taskId" activitiesNotification *ngIf="item.type == 'notification'" [item]="item"
              [ngClass]="{'read':item.viewed==='1','unread':item.viewed==='0'}" (click)="onNotificationClick(item)"
              (childEvent)="onToggle()"></li>
          </ng-template>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="notifyLength==0" class="text-center text-muted empty-notification-list">
      <i class="fa fa-bell-slash-o fa-2x margin-bottom-10"></i>
      <span style="font-size: 13px;">{{'header_notification_available' | i18n}}!</span>
    </div>
    <!-- end notification content -->

    <!-- footer: refresh area -->
    <span class="notf-footer d-flex justify-content-between align-items-center">
      <span style="opacity: 0.8;">
        {{'header_notification_lastupdate' | i18n}}: {{lastUpdate | moment:"h:mm:ss a"}}</span>
      <button type="button" (click)="update()" class="btn btn-xs btn-primary activity-reload">
        <i class="fa fa-refresh" *ngIf="!loading"></i>
        <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
        <span *ngIf="loading">{{'invoice_common_loading' | i18n}}...</span>
      </button>
    </span>
    <!-- end footer -->
  </div>
</div>
<div id="apiErrorMessageActivitiesPopup" class="custom-scroll" [saJquiDialog]="apiErrorMessageOptions">
  <h3>{{'api_error_message' | i18n}}</h3>
  <div class="text-right">
    <button title="{{'common_ok' | i18n}}" (click)="closeApiErrorMessagePopup()" type="submit"
      class="btn btn-primary search-btn margin-top-10">{{'common_ok' | i18n}}</button>
  </div>
</div>